import { Button, Icon, InlineStack, TextField } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import FilterSheet from './FilterSheet';
import './Styles/CustomFilters.css';
import { filtersProps } from './CustomFilterInterface';
import { SearchMinor } from '@shopify/polaris-icons';
import { useTour } from '../../Components/Other/tour';
import { useTranslation } from 'react-i18next';


const CustomFilter: React.FC<filtersProps> = (filtersProps: filtersProps) => {
    const { t } = useTranslation();
    const { isOpen, setCurrentStep } = useTour();
    const { btnVariants, btnText, appliedFilters, btnDisabled, btnLoading, hideSearchbar, searchValue, handleSearchbar, searchbarLabel, placeholder, disableSearchbar, clearSearchBar, onClearFunction } = filtersProps;
    const [active, setActive] = useState(false);

    const handleToggle = () => {
        if (active) {
            if (isOpen) {
                if ((filtersProps?.rowsLength ?? 0) > 0) {
                    setCurrentStep(a => a + 1);
                    setActive(!active);
                } else setCurrentStep(9);
            } else {
                setActive(!active);
            }
        } else {
            setActive(!active);
            if (isOpen) {
                setTimeout(() => {
                    setCurrentStep(a => a + 1);
                }, 300)
            }
        }
    }

    // ?uncomment below useEffect if you want to stop background scrolling

    // useEffect(() => {
    //     if (active) {
    //         document.body.style.overflow = "hidden";
    //         document.body.classList.add("filters__sheet--open");
    //     } else {
    //         document.body.style.removeProperty("overflow");
    //         document.body.classList.remove("filters__sheet--open");
    //     }
    // }, [active])
    return (
        <InlineStack gap='200' align='start' blockAlign={searchbarLabel ? 'end' : 'center'}>
            {
                !hideSearchbar ? <div className='Custom-Stack-Item--fill'>
                    <TextField prefix={<Icon source={SearchMinor} tone="base" />} placeholder={placeholder || 'Enter the value'} label={searchbarLabel} value={searchValue} onChange={handleSearchbar} disabled={disableSearchbar} autoComplete='off' clearButton={clearSearchBar} onClearButtonClick={onClearFunction} />
                </div> : <></>
            }
            <div className='bulktour_listing_filter'>
                <Button loading={btnLoading || false} variant={btnVariants || undefined} size='large' disabled={btnDisabled || false}
                    onClick={() => {
                        handleToggle();
                        const element: any = document.getElementsByClassName("Polaris-Tabs__Tab:not([aria-disabled='true']):focus-visible:not(:active)::after");
                        element?.classList?.remove("Polaris-Tabs__Tab:not([aria-disabled='true']):focus-visible:not(:active)::after");
                    }}
                >{btnText + `${Object.values(appliedFilters).length !== 0 ? ` (${Object.values(appliedFilters).length})` : ''}`}</Button>
            </div>
            <div className={active ? "filters__sheet--wrapper filters__sheet--active" : "filters__sheet--wrapper"}>
                <FilterSheet t={t} {...filtersProps} handleToggle={handleToggle} />
                {active && <div onClick={handleToggle} className="Polaris-Backdrop"></div>}
            </div>
        </InlineStack>
    )
}

export default CustomFilter;